import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function BusinessSettingIconSvg() {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_338_155197)">
        <path
          d="M33.9062 2.75C34.4758 2.75 34.9375 3.36561 34.9375 4.125V28.875C34.9375 29.6344 34.4758 30.25 33.9062 30.25H7.09375C6.52421 30.25 6.0625 29.6344 6.0625 28.875V4.125C6.0625 3.36561 6.52421 2.75 7.09375 2.75H33.9062ZM7.09375 0C5.38512 0 4 1.84683 4 4.125V28.875C4 31.1532 5.38512 33 7.09375 33H33.9062C35.6149 33 37 31.1532 37 28.875V4.125C37 1.84683 35.6149 0 33.9062 0H7.09375Z"
          fill="#DFE4E5"
        />
        <path
          d="M10.1875 9.625C10.1875 8.86561 10.6492 8.25 11.2188 8.25H29.7812C30.3508 8.25 30.8125 8.86561 30.8125 9.625C30.8125 10.3844 30.3508 11 29.7812 11H11.2188C10.6492 11 10.1875 10.3844 10.1875 9.625ZM10.1875 16.5C10.1875 15.7406 10.6492 15.125 11.2188 15.125H29.7812C30.3508 15.125 30.8125 15.7406 30.8125 16.5C30.8125 17.2594 30.3508 17.875 29.7812 17.875H11.2188C10.6492 17.875 10.1875 17.2594 10.1875 16.5ZM10.1875 23.375C10.1875 22.6156 10.6492 22 11.2188 22H23.5938C24.1633 22 24.625 22.6156 24.625 23.375C24.625 24.1344 24.1633 24.75 23.5938 24.75H11.2188C10.6492 24.75 10.1875 24.1344 10.1875 23.375Z"
          fill="#DFE4E5"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_338_155197"
          x="0"
          y="0"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_338_155197"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_338_155197"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default function BusinessSettingIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={BusinessSettingIconSvg} {...props} />
}
